import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import clickOutside from 'react-click-outside';
import classnames from 'classnames';

import FinishedTypingTextBox from '../../../../../../../../components/Form/FinishedTyping';
import Spinner from '../../../../../../../../components/Spinner/';
import './CompanySelector.scss';

class CompanySelector extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedEntry: null,
      visible: false,
      firstTimeLoad: true,
      SearchFinished: false,
      value: props.defaultValue || {
        id: null,
        name: '',
      },
    };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChange = this.handleChange.bind(this); // When finished typing
    this.handleTyping = this.handleTyping.bind(this); // Every Key press
    this.handleClick = this.handleClick.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
    this.respondOnChange = this.respondOnChange.bind(this); // Propogates Valuechange upstream
  }

  handleClickOutside(event) {
    this.setState({
      visible: false,
      selectedEntry: null,
    });
  }

  handleFocus(event) {
    this.setState({
      visible: true
    });
  }

  handleChange(event) { // When finished typing
    this.setState({
      firstTimeLoad: false,
      SearchFinished: false,
      value: {
        id: null,
        name: event.target.value
      },
    });

    if (event.target.value.length > 0) {
      this.props.SearchCompanies.refetch({
        searchParam: event.target.value
      }).then(() => {
        this.setState({
          SearchFinished: true,
        });
      });
    }
  }

  handleTyping(event) { // Every key press
    this.setState({
      SearchFinished: false,
      value: {
        id: null,
        name: event.target.value
      },
    });
    this.respondOnChange({
      id: null,
      name: event.target.value
    });
  }

  handleClick = newValue => () => {
    this.setState({
      visible: false,
      value: newValue,
      selectedEntry: null,
    });
    this.respondOnChange(newValue);
  }

  respondOnChange(val) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          value: val
        }
      });
    }
  }

  handleOnKey(event) {
    switch (event.keyCode) {
      case 38: // Up
        event.preventDefault();
        if (this.state.selectedEntry !== null && this.state.selectedEntry !== 0) {
          this.setState({
            selectedEntry: (this.state.selectedEntry - 1),
          });
        }
        break;
      case 40: // Down
        event.preventDefault();
        if (this.state.selectedEntry === null || this.state.selectedEntry !== (this.props.maxDisplayLength - 1)) {
          if (this.state.selectedEntry !== null) {
            this.setState({
              selectedEntry: (this.state.selectedEntry + 1),
            });
          } else {
            this.setState({
              selectedEntry: 0,
            });
          }
        }
        break;
      case 13: // Enter
        event.preventDefault();
        this.textInput.blur();
        if (this.state.selectedEntry !== null) {
          this.handleClick(this.props.SearchCompanies.searchCompanies[this.state.selectedEntry])();
        } else {
          this.handleClickOutside();
        }
        break;
      case 9: // Tab
        this.handleClickOutside();
        break;
    }
  }

  render() {
    const propsToOmit = ['onChange', 'name', 'onKeyDown', 'maxDisplayLength', 'SearchCompanies', 'defaultValue'];
    let spreadProps = {};

    Object.keys(this.props).forEach((value) => {
      if (propsToOmit.indexOf(value) === -1) {
        spreadProps[value] = this.props[value];
      }
    });

    return (
      <div className='CompanySelector'>
        <FinishedTypingTextBox value={this.state.value.name} delay={300} name={this.props.name} onChange={this.handleChange}
          onFocus={this.handleFocus} currentValue={this.handleTyping} onKeyDown={this.handleOnKey}
          inputRef={(input) => { this.textInput = input }} {...spreadProps} />
        {(this.props.SearchCompanies.loading && this.state.firstTimeLoad === false) ? <Spinner /> : null}
        <ul className='CompanySelector__SuggestionsWrap' style={(this.state.visible && this.state.SearchFinished) ? {} : { display: 'none' }}>
          {(this.props.SearchCompanies.searchCompanies || []).slice(0, this.props.maxDisplayLength).map((company, index) => (
            <li onClick={this.handleClick(company)}
              className={classnames({
                'CompanySelector__Suggestion': true,
                'CompanySelector__Suggestion--selected': this.state.selectedEntry === index
              })}
              key={company.id}>{company.name}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

CompanySelector.propTypes = {
  name: React.PropTypes.string.isRequired,
  maxDisplayLength: React.PropTypes.number,
  onChange: React.PropTypes.func
};

CompanySelector.defaultProps = {
  maxDisplayLength: 4,
};

const SearchCompaniesQuery = gql`
  query searchCompanies($searchParam: String) {
    searchCompanies(like: $searchParam) {
      id
      name
    }
  }
`;

export default graphql(SearchCompaniesQuery, {
  name: 'SearchCompanies'
})(clickOutside(CompanySelector));



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Experience/components/CompanySelector/index.js